export const el = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  opts: {
    className?: string;
    text?: string;
    attrs?: Record<string, string>;
    children?: readonly (HTMLElement | string)[];
  } = {},
): HTMLElementTagNameMap[K] => {
  const node = document.createElement(tag);
  if (opts.className) node.className = opts.className;
  if (opts.text !== undefined) node.textContent = opts.text;
  if (opts.attrs) {
    for (const [k, v] of Object.entries(opts.attrs)) node.setAttribute(k, v);
  }
  if (opts.children) {
    for (const c of opts.children) {
      node.append(typeof c === 'string' ? document.createTextNode(c) : c);
    }
  }
  return node;
};

export const button = (
  text: string,
  className: string,
  onClick: () => void,
  attrs?: Record<string, string>,
): HTMLButtonElement => {
  const b = el('button', { className, text, attrs: attrs ?? {} });
  b.addEventListener('click', onClick);
  return b;
};

export const clear = (node: HTMLElement): void => {
  node.replaceChildren();
};
